import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class TrimInterceptorService implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      if ((req.method === 'PUT' || req.method === 'POST') && req.responseType === 'json' && req?.body) {
        const reqCopy = req.clone();
        Object.keys(reqCopy.body).forEach((key) => {
          if (typeof reqCopy.body[key] === 'string' && reqCopy.body[key] !== reqCopy.body[key].trim()) {
            reqCopy.body[key] = reqCopy.body[key].trim();
          }
        });
        return next.handle(reqCopy);
      } else {
        return next.handle(req);
      }
    }

}
